module.exports = __webpack_public_path__ + "img/f9f29e9.png";